import { render } from "./TransportSettings.vue?vue&type=template&id=4131271e&scoped=true&ts=true"
import script from "./TransportSettings.vue?vue&type=script&lang=ts"
export * from "./TransportSettings.vue?vue&type=script&lang=ts"

import "./TransportSettings.vue?vue&type=style&index=0&id=4131271e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4131271e"]])

export default __exports__